import styled from "styled-components";

export const Wrapper = styled.div`
  font: small-caps bold 24px/1 sans-serif;
  margin: 0 var(--right-left-margin);
  text-align: center;
  line-height: 180%;

  h1 {
    font: small-caps bold 30px/1 sans-serif;
    margin: 0 auto var(--gap) auto;
  }

  p {
    font: small-caps 15px/1 sans-serif;
    line-height: 180%;
  }
`;

